import { AppCalendarEventsContext } from "../../Providers";
import {useContextSelector} from "use-context-selector";

export default function useAppCalendarAlertsActions(date) {
    const updateState = useContextSelector(AppCalendarEventsContext, ({ updateState }) => updateState)
    const alerts = useContextSelector(AppCalendarEventsContext, ({ state }) => state.monthAlerts[date])


    const handleOpenAlertsDrawer = (date) => {
        updateState({ isOpenAlertsDrawer: true, monthYear: date })
    }

    return {
        handleOpenAlertsDrawer, alerts
    }
}